import { TocPage, TOC_CASES, type TocCaseKey } from '@quebon/shared-learning'

// A4 portrait @ 96dpi (mm→px): 210mm × 297mm
const A4_WIDTH = 794
const A4_HEIGHT = 1123

const CASE_LABELS: Record<TocCaseKey, string> = {
  case1Basic: 'Case 1: 2-mod basic (lesson 5+6)',
  case2Max: 'Case 2: 2-mod max (lesson 9+10) — check last lesson not clipped',
  case3ThreeMod: 'Case 3: 3-mod (lesson 8+7+3)',
  case4Overflow: 'Case 4: 2-mod overflow (lesson 12+5)',
}

export default function TocPreviewDev() {
  const keys = Object.keys(TOC_CASES) as TocCaseKey[]
  return (
    <div style={{ background: '#f5f5f5', padding: 32, minHeight: '100vh' }}>
      <h1 style={{ marginBottom: 24, fontFamily: 'sans-serif' }}>TOC Preview — 4 Variant Cases</h1>
      {keys.map((key) => (
        <section key={key} style={{ marginBottom: 48 }}>
          <h2 style={{ fontFamily: 'sans-serif', fontSize: 18, marginBottom: 8 }}>{CASE_LABELS[key]}</h2>
          <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start' }}>
            <TocPage
              modules={TOC_CASES[key]}
              pageWidth={A4_WIDTH}
              pageHeight={A4_HEIGHT}
            />
          </div>
        </section>
      ))}
    </div>
  )
}
